// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoPlayback_videoContainer__66Hug","videoClip":"VideoPlayback_videoClip__8fN0D"};